import type { Map as MapboxMap } from 'mapbox-gl'

// Text markups draw as custom layers, which getStyle().layers never lists, so the order pass
// learns about them here. Mount order, bottom to top.
const byMap = new WeakMap<MapboxMap, string[]>()

// The editing hosts' session mount; MarkupTextLayer names its text layer `${idPrefix}-text`.
export const SESSION_MARKUP_PREFIX = 'markup-session'
export const SESSION_TEXT_LAYER_ID = `${SESSION_MARKUP_PREFIX}-text`

export function registerMarkupTextLayer(map: MapboxMap, layerId: string): void {
  const ids = byMap.get(map) ?? []
  if (!ids.includes(layerId)) byMap.set(map, [...ids, layerId])
}

export function unregisterMarkupTextLayer(
  map: MapboxMap,
  layerId: string,
): void {
  byMap.set(
    map,
    (byMap.get(map) ?? []).filter(id => id !== layerId),
  )
}

export function markupTextLayerIds(map: MapboxMap): string[] {
  return byMap.get(map) ?? []
}
